﻿export class BaseResponse {
    success: boolean;
    message: string;
}